import axiosInstance from './api.service'
import constants from '../constants/constants'

const endpointOrigin = "Quote/";

const Save = async (model) => await axiosInstance.post(endpointOrigin + 'Save', model, constants.REQUIRE_INTERCEPTORS)

const SaveClient = async (quoteId, client) => await axiosInstance.post(endpointOrigin + `SaveClient?quoteId=${quoteId}&client=${client}`, { }, constants.REQUIRE_INTERCEPTORS)

const SaveNote = async (quoteId, note) => await axiosInstance.post(endpointOrigin + `SaveNote?quoteId=${quoteId}&note=${note}`, { }, constants.REQUIRE_INTERCEPTORS)

const SaveProduct = async (model) => await axiosInstance.post(endpointOrigin + 'SaveProduct', model, constants.REQUIRE_INTERCEPTORS)

const SetQuoteProductMonths = async (model) => await axiosInstance.post(endpointOrigin + 'SetQuoteProductMonths', model, constants.REQUIRE_INTERCEPTORS)

const DeleteQuote = async (quoteId) => await axiosInstance.post(endpointOrigin + `DeleteQuote?quoteId=${quoteId}`, {}, constants.REQUIRE_INTERCEPTORS)

const SubmitQuote = async (quoteId) => await axiosInstance.post(endpointOrigin + `SubmitQuote?quoteId=${quoteId}`, {}, constants.REQUIRE_INTERCEPTORS)

const Get = async (id) => await axiosInstance.get(endpointOrigin + '?id=' + id, constants.REQUIRE_INTERCEPTORS)

const GetAll = async (companyId) => await axiosInstance.get(endpointOrigin + `GetAll?companyId=${companyId}`, constants.REQUIRE_INTERCEPTORS)

const GetQuoteProducts = async (quoteId) => await axiosInstance.get(endpointOrigin + `GetQuoteProducts?quoteId=${quoteId}`, constants.REQUIRE_INTERCEPTORS)

const GetBonusBuyNumbers = async (quoteId) => await axiosInstance.get(endpointOrigin + `GetBonusBuyNumbers?quoteId=${quoteId}`, constants.REQUIRE_INTERCEPTORS)

const DeleteQuoteProduct = async (quoteProductId) => await axiosInstance.get(endpointOrigin + `DeleteQuoteProduct?quoteProductId=${quoteProductId}`, constants.REQUIRE_INTERCEPTORS)

const GetQuoteSummaryData = async (hashId) => await axiosInstance.get(endpointOrigin + `GetQuoteSummaryData?hashId=${hashId}`, {
    requestHandlerEnabled: false,
    responseHandlerEnabled: true
})

const SaveQuoteLevelMonths = async (quoteId, months) => await axiosInstance.get(endpointOrigin + `SaveQuoteLevelMonths?quoteId=${quoteId}&months=${months}`, constants.REQUIRE_INTERCEPTORS)

const SendQuoteSummaryEmail = async (quoteId, emails) => await axiosInstance.get(endpointOrigin + `SendQuoteSummaryEmail?quoteId=${quoteId}&emails=${emails}`, constants.REQUIRE_INTERCEPTORS)

const DuplicateQuote = async (quoteId) => axiosInstance.post(endpointOrigin + 'DuplicateQuote?quoteId=' + quoteId, { }, constants.REQUIRE_INTERCEPTORS)

const IsMonthsRequired = async () => await axiosInstance.get(endpointOrigin + `IsMonthsRequired`, constants.REQUIRE_INTERCEPTORS)

export {
    Save,
    SaveClient,
    SaveNote,
    SaveProduct,
    SetQuoteProductMonths,
    DeleteQuote,
    SubmitQuote,
    Get,
    GetAll,
    GetQuoteProducts,
    GetBonusBuyNumbers,
    DeleteQuoteProduct,
    GetQuoteSummaryData,
    SendQuoteSummaryEmail,
    SaveQuoteLevelMonths,
    DuplicateQuote,
    IsMonthsRequired
}